module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("D O I N G   N O T H I N G")]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center02"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("A HISTORY OF LOAFERS, LOUNGERS, SLACKERS,")])]), _vm._v(" "), _c('p', {
    staticClass: "center01"
  }, [_c('span', {
    staticClass: "big2"
  }, [_vm._v("AND BUMS IN AMERICA")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big1"
  }, [_c('em', [_vm._v("Tom Lutz")])]), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780865477377_tp1.png"
    }
  }), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FARRAR, STRAUS AND GIROUX"), _c('br'), _vm._v("NEW YORK")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0fce8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780865477377_epub_tp_r1.vue
// module id = 63
// module chunks = 0